import { LitElement, html } from '@hh/global.js'

class StickyAsideColumns extends LitElement {
  constructor() {
    super();
    this.addEventListener('slotchange', () => {
      this.setActiveSection();
    });
  }

  firstUpdated() {
    this.initSmoothScrolling();
  }

  updated() {
    this.setActiveSection();
  }

  initSmoothScrolling() {
    const links = Array.from(this.querySelectorAll('.nav__item'));

    links.forEach((link, i) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.scrollIntoView(i);
      });

      link.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.scrollIntoView(i);
        }
      });
    });
  }

  scrollIntoView(index) {
    const sections = Array.from(this.querySelectorAll('.faq-page__section'));
    const section = sections[index];
    window.scrollTo({
      top: section.offsetTop - 20,
      behavior: 'smooth'
    });
  }

  setActiveSection() {
    const sections = Array.from(this.querySelectorAll('.faq-page__section'));
    const links = Array.from(this.querySelectorAll('.nav__item'));

    const updateActiveLink = () => {
      let currentActiveLink;
      sections.forEach((section, i) => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= 58) {
          currentActiveLink = links[i];
        }
      });

      if (currentActiveLink) {
        links.forEach((link) => {
          link.classList.remove('is-active');
        });
        currentActiveLink.classList.add('is-active');
      }
    };

    document.addEventListener('scroll', updateActiveLink);
  }

  render() {
    return html`
      <slot></slot>
    `;
  }
}

customElements.define('sticky-aside-columns', StickyAsideColumns);
